import type { DigitalTwinSettingTarget } from 'api/digitalTwin/digitalTwin.api'
import type { AppliedSettingSeries } from 'helpers/appliedSettingValues.helper/appliedSettingValues.types'
import { selectSeries } from 'helpers/appliedSettingValues.helper/seriesSelection.helper'

/** The most columns the table renders: 2,164 columns crashed the page. */
export const MAX_APPLIED_SETTING_COLUMNS = 1500

/** Systems with this flag get the "Filter by outcome" checkbox. */
export const FILTER_BY_OUTCOME_SYSTEM_FEATURE_FLAG = 'applied_settings_filter_by_outcome_option'

type AppliedSettingValuesStatus =
  | { kind: 'loadingModel' }
  | { kind: 'unavailable' }
  | { kind: 'noSelection' }
  | { kind: 'noMatch' }
  | { kind: 'tooManySeries'; columnCount: number }
  | { kind: 'selected'; selectedSeries: AppliedSettingSeries[] }

type AppliedSettingValuesStatusInput = {
  baseConfig: UiConfig | undefined
  baseConfigState: 'pending' | 'error' | 'success'
  isFiltered: boolean
  catalogue: AppliedSettingSeries[]
  selectedProperties: DigitalTwinSettingTarget[]
}

export function getAppliedSettingValuesStatus({
  baseConfig,
  baseConfigState,
  isFiltered,
  catalogue,
  selectedProperties,
}: AppliedSettingValuesStatusInput): AppliedSettingValuesStatus {
  if (baseConfigState === 'pending') {
    return { kind: 'loadingModel' }
  }
  if (baseConfigState === 'error' || !baseConfig) {
    return { kind: 'unavailable' }
  }
  if (!isFiltered) {
    return { kind: 'noSelection' }
  }

  const selectedSeries = selectSeries(catalogue, selectedProperties)
  if (!selectedSeries.length) {
    return { kind: 'noMatch' }
  }
  if (selectedSeries.length > MAX_APPLIED_SETTING_COLUMNS) {
    return { kind: 'tooManySeries', columnCount: selectedSeries.length }
  }

  return { kind: 'selected', selectedSeries }
}
